import '@bnnvara/typography';
import styled from 'styled-components';
export const IconButton = styled.button`
  background: ${({
  color
}) => color !== null && color !== void 0 ? color : 'transparent'};
  cursor: pointer;
  border: none;
  appearance: none;
  outline: none;
  display: inherit;
  padding: 0;
  margin: 0;
  line-height: 0;

  &:focus {
    outline: ${({
  theme
}) => `2px solid ${theme.base.blue}`};
    outline-offset: 2px;
  }
`;